import { Button, useToggle } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import i18n from 'modules/core/lib/i18n'
import type { ModalStates } from 'modules/core/lib/questionModalStates'

import type TemplateQuestion from 'modules/surveys/store/models/TemplateQuestion'

interface Props {
  templateQuestion: TemplateQuestion
  setOpenedModal: (value: ModalStates) => void
}

export default function Actions({ setOpenedModal }: Props) {
  const [isOpen, toggleOpen] = useToggle(false)

  const updateAction = {
    onClick: () => setOpenedModal('edit'),
    title: i18n.t('surveys.form.question_configs.update'),
  }

  const deleteAction = {
    onClick: () => setOpenedModal('delete'),
    type: 'wrong',
    title: i18n.t('surveys.form.question_configs.delete'),
  }

  const duplicateAction = {
    onClick: () => setOpenedModal('duplicate'),
    title: i18n.t('surveys.form.question_configs.duplicate.title'),
  }

  const actions = [updateAction, duplicateAction, deleteAction]

  return (
    <Popover attachment="top center" toggle={toggleOpen} open={isOpen}>
      <Button type="secondary" onClick={toggleOpen(true)} iconName="ellipsis" />
      <PopoverContent onClose={toggleOpen(false)} options={actions} />
    </Popover>
  )
}
